import React, { type FC, createContext, useMemo, useState } from 'react';

export type ItemToSubstitute = {
    stableId: string;
    name?: string;
    productId: string;
    variantId?: string;
    quantity: number;
    recipeName: string;
};

const RecipeProductSubstitutionContext = createContext<{
    itemToSubstitute: ItemToSubstitute | undefined;
    setItemToSubstitute: React.Dispatch<React.SetStateAction<ItemToSubstitute | undefined>>;
}>({ itemToSubstitute: undefined, setItemToSubstitute: () => {} });

export const RecipeProductSubstitutionProvider: FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    const [itemToSubstitute, setItemToSubstitute] = useState<ItemToSubstitute>();

    const memoizedValue = useMemo(() => {
        return { itemToSubstitute, setItemToSubstitute };
    }, [itemToSubstitute, setItemToSubstitute]);

    return (
        <RecipeProductSubstitutionContext.Provider value={memoizedValue}>
            {children}
        </RecipeProductSubstitutionContext.Provider>
    );
};

export const useRecipeProductSubstitutionContext = () => {
    return React.useContext(RecipeProductSubstitutionContext);
};
